
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("f9oto", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $10c160f154adce19$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Korean
var $10c160f154adce19$export$2e2bcd8739ae039 = {
    'fabric.emoji.add.custom.emoji.label': "\uB098\uB9CC\uC758 \uC774\uBAA8\uC9C0 \uCD94\uAC00",
    'fabric.emoji.add.label': "\uC774\uBAA8\uC9C0 \uCD94\uAC00",
    'fabric.emoji.cancel.label': "\uCDE8\uC18C",
    'fabric.emoji.categories.label': "\uC774\uBAA8\uC9C0 \uBC94\uC8FC \uC120\uD0DD",
    'fabric.emoji.categories.search.results': "\uAC80\uC0C9 \uACB0\uACFC",
    'fabric.emoji.category.activity': "\uD65C\uB3D9",
    'fabric.emoji.category.all.uploads': "\uBAA8\uB4E0 \uC5C5\uB85C\uB4DC",
    'fabric.emoji.category.flags': "\uD50C\uB798\uADF8",
    'fabric.emoji.category.foods': "\uC74C\uC2DD \uBC0F \uC74C\uB8CC",
    'fabric.emoji.category.frequent': "\uC790\uC8FC \uC0AC\uC6A9",
    'fabric.emoji.category.nature': "\uC790\uC5F0",
    'fabric.emoji.category.objects': "\uBB3C\uAC74",
    'fabric.emoji.category.people': "\uC0AC\uC6A9\uC790",
    'fabric.emoji.category.places': "\uC5EC\uD589 \uBC0F \uC7A5\uC18C",
    'fabric.emoji.category.productivity': "\uC0DD\uC0B0\uC131",
    'fabric.emoji.category.symbols': "\uAE30\uD638",
    'fabric.emoji.category.user.uploads': "\uB0B4 \uC5C5\uB85C\uB4DC",
    'fabric.emoji.choose.file.screenReaderDescription': "\uC774\uBAA8\uC9C0\uC758 \uD30C\uC77C\uC744 \uC120\uD0DD\uD558\uC138\uC694. JPG, PNG \uB610\uB294 GIF\uC785\uB2C8\uB2E4. \uCD5C\uB300 \uD06C\uAE30 1MB",
    'fabric.emoji.choose.file.title': "\uD30C\uC77C \uC120\uD0DD",
    'fabric.emoji.delete.description': "\uC774 \uC774\uBAA8\uC9C0\uC758 \uBAA8\uB4E0 \uAE30\uC874 \uC778\uC2A4\uD134\uC2A4\uAC00 {emojiShortName}(\uC73C)\uB85C \uAD50\uCCB4\uB429\uB2C8\uB2E4",
    'fabric.emoji.delete.label': "\uC81C\uAC70",
    'fabric.emoji.delete.screenreader.tooltip': "{shortName} \uC774\uBAA8\uC9C0\uB97C \uC0AD\uC81C\uD558\uB824\uBA74 \uBC31\uC2A4\uD398\uC774\uC2A4 \uD0A4\uB97C \uB204\uB974\uC138\uC694",
    'fabric.emoji.delete.title': "\uC774\uBAA8\uC9C0 \uC81C\uAC70",
    'fabric.emoji.delete.tooltip': "\uC0AD\uC81C",
    'fabric.emoji.emojipicker.emoi.roledescription': "\uC774\uBAA8\uC9C0 \uBC84\uD2BC",
    'fabric.emoji.emojipicker.error': "\uC624\uB958!",
    'fabric.emoji.error.delete.failed': "\uC81C\uAC70 \uC2E4\uD328",
    'fabric.emoji.error.image.too.big': "\uC120\uD0DD\uB41C \uC774\uBBF8\uC9C0\uAC00 1MB\uBCF4\uB2E4 \uD07D\uB2C8\uB2E4",
    'fabric.emoji.error.invalid.image': "\uC120\uD0DD\uB41C \uC774\uBBF8\uC9C0\uAC00 \uC720\uD6A8\uD558\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4",
    'fabric.emoji.error.upload.failed': "\uC5C5\uB85C\uB4DC \uC2E4\uD328",
    'fabric.emoji.error.upload.timeout': "\uC5C5\uB85C\uB4DC \uC2DC\uAC04 \uCD08\uACFC\uB428",
    'fabric.emoji.image.requirements': "JPG, PNG \uB610\uB294 GIF. \uCD5C\uB300 1 MB \uD06C\uAE30.",
    'fabric.emoji.name.ariaLabel': "\uC0C8 \uC774\uBAA8\uC9C0\uC758 \uC774\uB984\uC744 \uC785\uB825\uD558\uC138\uC694.",
    'fabric.emoji.picker': "\uC774\uBAA8\uC9C0 \uC120\uD0DD\uAE30",
    'fabric.emoji.pickerlist.grid': "{showSearchResults, select, true {\uAC80\uC0C9 \uACB0\uACFC} other {\uC774\uBAA8\uC9C0}}",
    'fabric.emoji.pickerlist.tabpanel': "\uC774\uBAA8\uC9C0 \uB3D9\uC791 \uBC0F \uBAA9\uB85D \uD328\uB110",
    'fabric.emoji.placeholder': "\uC608: \uC548\uB155\uD558\uC138\uC694",
    'fabric.emoji.preview': "\uC0C8\uB85C\uC6B4 \uC774\uBAA8\uC9C0 {emoji}\uAC00 \uBA4B\uC9C0\uB124\uC694.",
    'fabric.emoji.preview.title': "\uBBF8\uB9AC \uBCF4\uAE30",
    'fabric.emoji.retry.label': "\uB2E4\uC2DC \uC2DC\uB3C4",
    'fabric.emoji.search.label': "\uC774\uBAA8\uC9C0 \uC774\uB984",
    'fabric.emoji.search.placeholder': "\uAC80\uC0C9",
    'fabric.emoji.search.status': "\uBAA8\uB4E0 \uC774\uBAA8\uC9C0 \uD45C\uC2DC \uC911",
    'fabric.emoji.select.skin.list.ariaLabel': "\uD53C\uBD80\uC0C9 \uC120\uD0DD\uAE30",
    'fabric.emoji.select.skin.tone.ariaLabel': "\uD53C\uBD80\uC0C9\uC744 \uC120\uD0DD\uD558\uC138\uC694. {selectedTone} \uC120\uD0DD\uB428"
};

});


//# sourceMappingURL=ko.c06411bc.js.map
